/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse, HttpEvent, HttpContext } from '@angular/common/http';
import { Observable } from 'rxjs';
import { OpenApiHttpParams, QueryParamStyle } from '../query.params';

// @ts-ignore
import { AggregatedCurveAckDto } from '../model/aggregatedCurveAckDto';
// @ts-ignore
import { AggregatedCurveFilter } from '../model/aggregatedCurveFilter';
// @ts-ignore
import { AggregatedCurveFilterSingleOrder } from '../model/aggregatedCurveFilterSingleOrder';
// @ts-ignore
import { ErrorMessage } from '../model/errorMessage';
// @ts-ignore
import { QueueIdDto } from '../model/queueIdDto';
// @ts-ignore
import { QueuedAck } from '../model/queuedAck';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS } from '../variables';
import { Configuration } from '../configuration';
import { BaseService } from '../api.base.service';

export interface CreateAggregatedCurveRequestParams {
  aggregatedCurveFilter: AggregatedCurveFilter;
}

export interface CreateAggregatedCurveAsyncRequestParams {
  aggregatedCurveFilter: AggregatedCurveFilter;
}

export interface CreateAggregatedCurveByOrderIdRequestParams {
  aggregatedCurveFilterSingleOrder: AggregatedCurveFilterSingleOrder;
}

export interface GetAggregatedCurveAsyncResultRequestParams {
  id: number;
}

@Injectable({
  providedIn: 'root',
})
export class AnalyticsControllerService extends BaseService {
  constructor(
    protected httpClient: HttpClient,
    @Optional() @Inject(BASE_PATH) basePath: string | string[],
    @Optional() configuration?: Configuration,
  ) {
    super(basePath, configuration);
  }

  /**
   * Gets aggregated data by trades for specified filter
   * @endpoint post /v1/analytics/aggregated-data-v2
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public createAggregatedCurve(
    requestParameters: CreateAggregatedCurveRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<AggregatedCurveAckDto>;
  public createAggregatedCurve(
    requestParameters: CreateAggregatedCurveRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<HttpResponse<AggregatedCurveAckDto>>;
  public createAggregatedCurve(
    requestParameters: CreateAggregatedCurveRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<HttpEvent<AggregatedCurveAckDto>>;
  public createAggregatedCurve(
    requestParameters: CreateAggregatedCurveRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<any> {
    const aggregatedCurveFilter = requestParameters?.aggregatedCurveFilter;
    if (aggregatedCurveFilter === null || aggregatedCurveFilter === undefined) {
      throw new Error(
        'Required parameter aggregatedCurveFilter was null or undefined when calling createAggregatedCurve.',
      );
    }

    let localVarHeaders = this.defaultHeaders;

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept(['application/json']);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/v1/analytics/aggregated-data-v2`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<AggregatedCurveAckDto>('post', `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: aggregatedCurveFilter,
      responseType: <any>responseType_,
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress,
    });
  }

  /**
   * Gets aggregated data by trades for specified filter
   * @endpoint post /v1/analytics/aggregated-data-v2-async
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public createAggregatedCurveAsync(
    requestParameters: CreateAggregatedCurveAsyncRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<QueueIdDto>;
  public createAggregatedCurveAsync(
    requestParameters: CreateAggregatedCurveAsyncRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<HttpResponse<QueueIdDto>>;
  public createAggregatedCurveAsync(
    requestParameters: CreateAggregatedCurveAsyncRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<HttpEvent<QueueIdDto>>;
  public createAggregatedCurveAsync(
    requestParameters: CreateAggregatedCurveAsyncRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<any> {
    const aggregatedCurveFilter = requestParameters?.aggregatedCurveFilter;
    if (aggregatedCurveFilter === null || aggregatedCurveFilter === undefined) {
      throw new Error(
        'Required parameter aggregatedCurveFilter was null or undefined when calling createAggregatedCurveAsync.',
      );
    }

    let localVarHeaders = this.defaultHeaders;

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept(['application/json']);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/v1/analytics/aggregated-data-v2-async`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<QueueIdDto>('post', `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: aggregatedCurveFilter,
      responseType: <any>responseType_,
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress,
    });
  }

  /**
   * Gets aggregated curves data for specified order id
   * @endpoint post /v1/analytics/aggregated-data-single-order
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public createAggregatedCurveByOrderId(
    requestParameters: CreateAggregatedCurveByOrderIdRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<AggregatedCurveAckDto>;
  public createAggregatedCurveByOrderId(
    requestParameters: CreateAggregatedCurveByOrderIdRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<HttpResponse<AggregatedCurveAckDto>>;
  public createAggregatedCurveByOrderId(
    requestParameters: CreateAggregatedCurveByOrderIdRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<HttpEvent<AggregatedCurveAckDto>>;
  public createAggregatedCurveByOrderId(
    requestParameters: CreateAggregatedCurveByOrderIdRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<any> {
    const aggregatedCurveFilterSingleOrder = requestParameters?.aggregatedCurveFilterSingleOrder;
    if (aggregatedCurveFilterSingleOrder === null || aggregatedCurveFilterSingleOrder === undefined) {
      throw new Error(
        'Required parameter aggregatedCurveFilterSingleOrder was null or undefined when calling createAggregatedCurveByOrderId.',
      );
    }

    let localVarHeaders = this.defaultHeaders;

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept(['application/json']);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/v1/analytics/aggregated-data-single-order`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<AggregatedCurveAckDto>('post', `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: aggregatedCurveFilterSingleOrder,
      responseType: <any>responseType_,
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress,
    });
  }

  /**
   * Gets aggregated data by trades for specified filter
   * @endpoint get /v1/analytics/aggregated-data-v2-async/{id}
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public getAggregatedCurveAsyncResult(
    requestParameters: GetAggregatedCurveAsyncResultRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<QueuedAck>;
  public getAggregatedCurveAsyncResult(
    requestParameters: GetAggregatedCurveAsyncResultRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<HttpResponse<QueuedAck>>;
  public getAggregatedCurveAsyncResult(
    requestParameters: GetAggregatedCurveAsyncResultRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<HttpEvent<QueuedAck>>;
  public getAggregatedCurveAsyncResult(
    requestParameters: GetAggregatedCurveAsyncResultRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling getAggregatedCurveAsyncResult.');
    }

    let localVarHeaders = this.defaultHeaders;

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept(['application/json']);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/v1/analytics/aggregated-data-v2-async/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'number', dataFormat: 'int64' })}`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<QueuedAck>('get', `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      responseType: <any>responseType_,
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress,
    });
  }
}
